import gsap from "gsap";
import { useEffect, useRef } from "react";

export const useStoriesAnimation = (onComplete: () => void) => {
  const $root = useRef<HTMLDivElement | null>(null);
  const $images = useRef<(HTMLDivElement | null)[]>([]);
  const $icons = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: $root.current,
        start: "top top",
        end: "bottom 50%",
        scrub: 1,
      },
      onComplete: () => {
        if (onComplete) onComplete();
      },
    });

    timeline.to($images.current, {
      "--progress": 1,
      duration: 1,
      ease: "none",
      stagger: 0.01,
    });

    timeline.to(
      $icons.current,
      {
        "--progress": 1,
        duration: 1,
        ease: "none",
        stagger: 0.05,
      },
      "<",
    );

    return () => {
      timeline.revert();
    };
  }, []);

  return {
    $root,
    $images,
    $icons,
  };
};
